import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "./firebase"; // Adjust the path to your firebase.js initialization

/**
 * Saves the user's tutorial state to Firestore.
 * @param {string} uid - The user's unique ID.
 * @param {object} state - The tutorial state object to save (e.g., { tutorialDisabled: true, completedSteps: {...} }).
 */
export const saveUserTutorialState = async (uid, state) => {
  if (!uid) {
    console.error("User UID is required to save tutorial state.");
    return;
  }
  try {
    const tutorialStateRef = doc(db, "users", uid, "tutorialState", "main"); // Using "main" as a specific doc ID for the state
    await setDoc(tutorialStateRef, state, { merge: true }); // Use merge: true to update fields without overwriting the whole doc if not all fields are provided
    // console.log("User tutorial state saved successfully.");
  } catch (error) {
    console.error("Error saving user tutorial state:", error);
  }
};

/**
 * Loads the user's tutorial state from Firestore.
 * @param {string} uid - The user's unique ID.
 * @returns {Promise<object|null>} The tutorial state object or null if not found or an error occurs.
 */
export const loadUserTutorialState = async (uid) => {
  if (!uid) {
    console.error("User UID is required to load tutorial state.");
    return null;
  }
  try {
    const tutorialStateRef = doc(db, "users", uid, "tutorialState", "main");
    const docSnap = await getDoc(tutorialStateRef);
    if (docSnap.exists()) {
      // console.log("User tutorial state loaded successfully:", docSnap.data());
      return docSnap.data();
    } else {
      // console.log("No tutorial state found for user.");
      return null; // No state document exists
    }
  } catch (error) {
    console.error("Error loading user tutorial state:", error);
    return null;
  }
};
